import dayjs from "dayjs";
import { isNil } from "lodash";

import { Change } from "@similarweb/ui-components";

import { useFormattedDuration } from "app/pages/activation/hooks/helpers/useFormattedDuration";
import { translate } from "app/filters/i18nFilter";
import { abbrNumberFilter, changeFilter, percentageFilter } from "app/filters/ngFilters";

import { BenchmarkGranularity } from "../../../types/common";
import { VOLUME_LABEL } from "../../Topics/Topic/Share/texts";
import { StyledHeader, StyledItemWrapper } from "../ChartTableTooltip/styles";

import * as SC from "./styles";
import { MOM, WOW } from "./texts";
import type { TrendChangeTooltipSchema } from "./type";
import { ValueType } from "./type";

export const TrendChangeTooltip = ({
    value,
    change,
    granularity,
    date,
    valueType = ValueType.Absolute,
}: TrendChangeTooltipSchema) => {
    const isMonthly = granularity === BenchmarkGranularity.MONTHLY;
    const granularityText = isMonthly ? MOM : WOW;

    const prepareDuration = () => {
        if (!isMonthly) {
            const lastDay = dayjs(date).add(6, "day").format("YYYY-MM-DD");
            return `${date}-${lastDay}`;
        }

        return `${date}-${date}`;
    };

    const { formattedDuration } = useFormattedDuration(granularity, prepareDuration(), true);
    const formatedValue =
        valueType === ValueType.Absolute ? abbrNumberFilter()(value) : `${percentageFilter()(value, 1)}%`;

    return (
        <SC.TooltipContainer>
            <SC.Duration>{formattedDuration}</SC.Duration>

            <StyledHeader>
                <SC.Name>{translate(VOLUME_LABEL, { granularity })}</SC.Name>
                <SC.Name>{translate(granularityText)}</SC.Name>
            </StyledHeader>

            <StyledItemWrapper>
                <SC.Value>{formatedValue}</SC.Value>

                {isNil(change) ? (
                    <SC.EmptyValue>-</SC.EmptyValue>
                ) : (
                    <Change
                        value={changeFilter()(change)}
                        isDecrease={change < 0}
                    />
                )}
            </StyledItemWrapper>
        </SC.TooltipContainer>
    );
};
